import { render, staticRenderFns } from "./ConversationsListVirtual.vue?vue&type=template&id=32df7613&scoped=true"
import script from "./ConversationsListVirtual.vue?vue&type=script&lang=js"
export * from "./ConversationsListVirtual.vue?vue&type=script&lang=js"
import style0 from "./ConversationsListVirtual.vue?vue&type=style&index=0&id=32df7613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df7613",
  null
  
)

export default component.exports